import { BaseComponent, IStateBase } from 'components/BaseComponent';
import React, { RefObject } from 'react';
import { SvgIcon } from 'components/SvgIcon';

const styles = require('./paymentLoader.css');

interface IState extends IStateBase {
  next: number;
  active: number;
  elements: number;
}

export default class PaymentLoader extends BaseComponent<IState> {

  public loaderElement: RefObject<any>;
  public timer: any;

  constructor(props: any) {
    super(props);
    this.loaderElement = React.createRef();
  }

  componentDidMount() {
    const length = this.loaderElement.current.children.length;

    this.loaderElement.current.children[0].classList.add('active');
    this.setState({ active: 0, next: 1, elements: length });
    this.timer = setInterval(() => this.handleAnimation(), 1500);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  handleAnimation() {
    const next = this.state.next < this.state.elements ? this.state.next : 0;

    this.loaderElement.current.children[this.state.active].classList.remove('active');
    this.loaderElement.current.children[next].classList.add('active');

    this.setState({ active: next });
    this.setState({ next: next + 1 });
  }

  render() {
    return (
      <div className={styles.component} ref={this.loaderElement}>
        <div className='icon'>
          <SvgIcon name='videoPaymentLoader' />
        </div>
        <div className='icon'>
          <SvgIcon name='ticketPaymentLoader' />
        </div>
        <div className='icon'>
          <SvgIcon name='relogioPaymentLoader' />
        </div>
        <div className='icon'>
          <SvgIcon name='camisetaPaymentLoader' />
        </div>
        <div className='icon'>
          <SvgIcon name='ebookPaymentLoader' />
        </div>
        <div className='icon'>
          <SvgIcon name='tenisPaymentLoader' />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/PaymentButton/PaymenteMessage/PaymentInProgress/PaymentLoader/index.tsx